import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { closeDialog } from "../../../../store/actionCreators/dialog";
import { removeMemberRequest } from "../../../../store/actionCreators/member";

const DeleteMember =() => {
  const { t } = useTranslation();  
    const dispatch = useDispatch();
    const history = useHistory();
    const dialog = useSelector(state=>state.dialog);
    const close = () => {
        dispatch(closeDialog());
    };
    const memberId = dialog.params.memberId;

    const confirm = useCallback(() => {
        if(dialog.params.onConfirm) {
            dialog.params.onConfirm();
            history.push(`/club/${dialog.params.clubId}/members`);
        }
        dispatch(removeMemberRequest({memberId}));
    }, [dialog, memberId]);

    return (
        <div className={`deleteClubMember`}>
            <div className={`deleteText`}>{t('deleteClubMember')}</div>
            <div className={`dialogConfirmBox`}>
                <button className={`primary`} onClick={confirm}>{t('button.confirm')}</button>
                <button className={`tertiary`} onClick={close}>{t('button.cancel')}</button>
            </div>
        </div>
    );
};

export default DeleteMember;
